import { Tag } from '@nespresso-design-system/components';
import ProductTag from '@nespresso/catalog-components-react/controls/ProductTag';
import type { Product } from '@/domain/Product';
import styles from './Tags.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';

export type TagsProps = {
  product: Product;
};
export default function Tags({
  product: { highlightLabels = [], inStock }
}: TagsProps) {
  const { t } = useTranslations();
  const outOfStockTranslation = t(
    'productList.productTagsSection.outOfStockLabel'
  );
  if (highlightLabels.length === 0) return null;

  return (
    <div class={styles.container}>
      {!inStock && outOfStockTranslation ? (
        <Tag label={outOfStockTranslation} variant="informative" />
      ) : (
        highlightLabels.map((highlightLabel) => (
          <ProductTag
            name={highlightLabel.label}
            key={highlightLabel.id || highlightLabel.label}
            bgColor={highlightLabel.bgColor}
            color={highlightLabel.fgColor}
          />
        ))
      )}
    </div>
  );
}
